import { generatePath } from 'react-router-dom'
import { CONTENT_PREFERENCES_PATH } from 'paths'
import { Workspace } from 'types'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { AudioSettings02 } from 'blaze-ui/icons/24'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuContentPreferencesItem = ({ workspace, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={AudioSettings02}
      activeIcon={AudioSettings02}
      to={generatePath(CONTENT_PREFERENCES_PATH, { workspaceId: workspace.id })}
      onPress={onPress}
      label="Content Preferences"
    />
  )
}

export { NavMenuContentPreferencesItem }
